import { ISkills } from "../../types";
import { SkillsItem } from "./skills-item";

interface SkillsDetailsProps {
  skills: ISkills[];
}

const SkillsDetails = ({ skills }: SkillsDetailsProps) => {
  return (
    <div className="border shadow-sm p-6 rounded-lg">
      <p className="text-xl mb-2">Skills</p>
      <div className="flex flex-wrap gap-2">
        {skills.length > 0 ? (
          skills.map((skill) => (
            <SkillsItem label={skill.name} key={skill._id} />
          ))
        ) : (
          <p className="text-gray-500 italic">No skill added!</p>
        )}
      </div>
    </div>
  );
};

export default SkillsDetails;
